import { AdvancedEventEmitter, EventBroker, RestorablePropEventBroker } from '../EventBrokers';
export class PropEventBrokerCollection extends AdvancedEventEmitter {
    constructor() {
        super(...arguments);
        this.changeableMap = new Map();
        this.onAnyPropChanged = new EventBroker(this);
    }
    brokerChangedHandler(blah) {
        this.onAnyPropChanged.emit(blah);
    }
    ;
    serializeName(name) {
        return name;
    }
    createPropEventBroker(name, emitter, initialValue, options) {
        const changeable = new RestorablePropEventBroker(emitter, initialValue, options);
        changeable.registerEnsureOnce(() => {
            this.brokerChangedHandler(name);
        });
        this.changeableMap.set(name, { changeable, serializer: options?.serializer });
        return changeable;
    }
    getChangedProps() {
        return Array.from(this.changeableMap.entries())
            .filter(([, { changeable }]) => changeable.isChanged())
            .map(([key, { changeable, serializer: passedSerializer }]) => {
            let serializedItem;
            if (passedSerializer) {
                serializedItem = passedSerializer(changeable);
            }
            else if (changeable.serialize()) {
                serializedItem = changeable.serialize();
            }
            else {
                serializedItem = this.serializeName(key);
            }
            return { propName: key, value: serializedItem };
        });
    }
    restore() {
        this.changeableMap.forEach(({ changeable }) => changeable.restore());
    }
    commit() {
        this.changeableMap.forEach(({ changeable }) => changeable.commit());
    }
    hasChanges() {
        return this.getChangedProps().length > 0;
    }
    getChangeablePropsCount() {
        return this.changeableMap.size;
    }
}
//# sourceMappingURL=PropEventBrokerCollection.js.map